export default "__VITE_ASSET__B$MvfFXL__"